import { inject, Injectable, WritableSignal } from "@angular/core";
import { DocumentApiService } from "./document-api.service";
import { EntityFacadeService } from "../../../../shared/store/entity-store/entity-facade.service";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { DocumentState, DocumentStoreService } from "./document-store.service";
import { filter, firstValueFrom, map, tap } from "rxjs";
import { FileType } from "../../models/file-type";
import { UpdateStatus } from "../../../../shared/store/utils/store-utils.service";

@Injectable({ providedIn: "root" })
export class DocumentFacadeService extends EntityFacadeService<
  FileType,
  DocumentApiService,
  DocumentState,
  EntityMetadata,
  DocumentStoreService
> {
  constructor() {
    const api = inject(DocumentApiService);
    const store = inject(DocumentStoreService);
    super(api, store);
  }

  @UpdateStatus
  async upload(
    file: File,
    uploadPercentValue: WritableSignal<number>,
  ): Promise<FileType> {
    const res = await firstValueFrom(
      this.api.uploadFile(file).pipe(
        tap((data) => {
          uploadPercentValue.set(data.progress);
        }),
        filter((data) => data.file !== undefined),
        map((data) => data.file),
      ),
    );
    return res;
  }
}
